<template>
  <div class="ec-checkbox-wrapper">
  <!-- Block mode: full clickable card with description -->
  <div
    v-if="isBlock"
    class="ec-checkbox-block"
    :class="{
      'ec-checkbox-block--checked': value,
      'ec-checkbox-block--disabled': disabled,
    }"
    role="checkbox"
    :aria-checked="String(value)"
    :aria-disabled="String(disabled)"
    tabindex="0"
    @click="toggle"
    @keydown.space.prevent="toggle"
    @keydown.enter.prevent="toggle"
  >
    <div class="ec-checkbox-block__check">
      <div class="ec-checkbox-block__box" :class="{ 'ec-checkbox-block__box--checked': value }">
        <i v-if="value" class="bi bi-check-lg" />
      </div>
    </div>
    <div class="ec-checkbox-block__content">
      <span v-if="label" class="ec-checkbox-block__label">{{ label }}</span>
      <span v-if="description" class="ec-checkbox-block__description">{{ description }}</span>
    </div>
  </div>

  <!-- Inline mode: simple checkbox -->
  <label
    v-else
    class="ec-checkbox"
    :class="{ 'ec-checkbox--disabled': disabled }"
  >
    <input
      type="checkbox"
      class="ec-checkbox__input"
      :checked="value"
      :disabled="disabled"
      @change="$emit('input', $event.target.checked)"
    />
    <span class="ec-checkbox__indicator" :class="{ 'ec-checkbox__indicator--checked': value }">
      <i v-if="value" class="bi bi-check-lg" />
    </span>
    <span v-if="label" class="ec-checkbox__label">{{ label }}</span>
  </label>
  </div>
</template>

<script>
export default {
  name: 'EcCheckbox',

  model: {
    prop: 'value',
    event: 'input',
  },

  props: {
    value: { type: Boolean, default: false },
    label: { type: String, default: '' },
    description: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    block: { type: Boolean, default: false },
  },

  computed: {
    isBlock() {
      return this.block || !!this.description
    },
  },

  methods: {
    toggle() {
      if (!this.disabled) this.$emit('input', !this.value)
    },
  },
}
</script>
